module.exports = __webpack_public_path__ + "static/img/knives32.29b6da4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives32.jpg
// module id = 7AlU
// module chunks = 0